module.exports = __webpack_public_path__ + "img/belize.42ed3ac4.svg";